import { USE_DAILY_PREBUILT_IFRAME } from '@/constants/sessionCall';
import {
	SessionCallPageShellCustom,
	type SessionCallPageShellProps,
} from '@/components/session-call/SessionCallPageShell.custom';
import { SessionCallPageShellPrebuilt } from '@/components/session-call/SessionCallPageShellPrebuilt';

const SessionCallPageShell = (props: SessionCallPageShellProps) => {
	if (USE_DAILY_PREBUILT_IFRAME) {
		return <SessionCallPageShellPrebuilt {...props} />;
	}

	return <SessionCallPageShellCustom {...props} />;
};

export { SessionCallPageShell };
export type { SessionCallPageShellProps };
